import React, { ReactElement, useCallback } from "react";
import { CoObjectItem } from "../interfaces/CoObject";
import {
  ElaborationStatusItem,
  elaborationStatusItemIsBlocking,
} from "../../redux/feature/object/remote-elaborations-slice";
import { useFilteredElaborations } from "./GenericElaborationSelector";

export interface ObjectElaborationSelectorProps {
  coObject: CoObjectItem;
  children: (coObject: CoObjectItem, elaborationItem?: ElaborationStatusItem) => ReactElement;
}

export const ObjectElaborationSelector: React.FunctionComponent<ObjectElaborationSelectorProps> = (props) => {
  const { coObject } = props;

  const objectElabFindFunction = useCallback(
    (item: ElaborationStatusItem) =>
      item.contentControlId == coObject.contentControlId?.toString() &&
      item.elaborationType !== "EXPORT" &&
      item.elaborationType !== "IMPORT" &&
      elaborationStatusItemIsBlocking(item),
    //has to handle SHEET_AND_AREA type elaboration
    [coObject.contentControlId]
  );

  const elaborationItem = useFilteredElaborations({
    findFunction: objectElabFindFunction,
  });

  return props.children(coObject, elaborationItem);
};
